import React, { Fragment } from 'react'
import { history } from '../../../index'
import { withRouter } from 'react-router-dom'

class ProductPlan extends React.PureComponent {
  UNSAFE_componentWillMount() {
    const { productTypes = [] } = this.props

    let userPayload = JSON.parse(localStorage.getItem('userPayload'))
    if (userPayload?.selectedCluster?.productType) {
      let productType =
        userPayload?.selectedCluster?.productType === undefined
          ? ''
          : userPayload?.selectedCluster?.productType?.toLowerCase()
      const validProductType = productTypes.includes(productType)

      if (!validProductType && !window.location.toString().includes('/reportlink')) {
        let professionalURL =
          '/' + userPayload.clusterId + '/' + userPayload.scope_id + '/upgrade/professional_plan'
        let enterpriseURL =
          '/' + userPayload.clusterId + '/' + userPayload.scope_id + '/upgrade/enterprise_plan'
        let redirectURL = enterpriseURL
        if (productType === 'essential') {
          if (productTypes.includes('professional')) {
            redirectURL = professionalURL
          }
        }
        history.push(redirectURL)
      }
    }
  }

  render() {
    const { children, productTypes = [] } = this.props
    let userPayload = JSON.parse(localStorage.getItem('userPayload'))
    if (userPayload?.selectedCluster?.productType) {
      let productType =
        userPayload?.selectedCluster?.productType === undefined
          ? ''
          : userPayload?.selectedCluster?.productType?.toLowerCase()
      const validProductType = productTypes.includes(productType)

      var AuthorizedChildren = () => {
        if (!validProductType) {
          return null
        }
        // if access is successful render children
        return <Fragment>{children}</Fragment>
      }
    } else {
      var AuthorizedChildren = () => {
        // if access is successful render children
        return <Fragment>{children}</Fragment>
      }
    }
    return AuthorizedChildren()
  }
}

export default withRouter(ProductPlan)
